import { useEffect } from 'react';
import { useOptimizely } from '../../../utils/optimizely';
import { PREMIER_SAVINGS_PATH } from '../../../constants/path-constants';
import { EXPERIMENTS, EXPERIMENT_OPTS } from '../../../constants/optimizely';

const useEmailExperiment = location => {
  const { activateExperiment, isReady, getExperiment } = useOptimizely();
  const emailCaptureExperiment = getExperiment(EXPERIMENTS.PREMIER_SAVING_CAPTURE_EMAIL);
  const isPS = location?.pathname.includes(PREMIER_SAVINGS_PATH);

  useEffect(() => {
    if (isPS) {
      activateExperiment(EXPERIMENTS.PREMIER_SAVING_CAPTURE_EMAIL);
    }
  }, [activateExperiment, isPS]);

  return {
    isReady,
    captureEmailExperiment:
      isReady && isPS && emailCaptureExperiment === EXPERIMENT_OPTS.PREMIER_SAVING_CAPTURE_EMAIL.VariantA
  };
};

export default useEmailExperiment;
